var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_1430)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2396_1430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.567 77.5265C125.91 77.5265 121.962 70.6974 126.764 62.3212C129.538 57.4662 127.884 51.2774 123.029 48.5031L113.799 43.2212C109.584 40.7137 104.143 42.2075 101.635 46.4223L101.048 47.436C96.2465 55.8123 88.3504 55.8123 83.4954 47.436L82.9085 46.4223C80.5077 42.2075 75.0658 40.7137 70.851 43.2212L61.6212 48.5031C56.7662 51.2774 55.1123 57.5195 57.8865 62.3745C62.7416 70.6974 58.7935 77.5265 49.1368 77.5265C43.5883 77.5265 39 82.0614 39 87.6633V97.0532C39 102.602 43.5349 107.19 49.1368 107.19C58.7935 107.19 62.7416 114.019 57.8865 122.395C55.1123 127.25 56.7662 133.439 61.6212 136.213L70.851 141.495C75.0658 144.003 80.5077 142.509 83.0153 138.294L83.6021 137.28C88.4038 128.904 96.2999 128.904 101.155 137.28L101.742 138.294C104.249 142.509 109.691 144.003 113.906 141.495L123.136 136.213C127.991 133.439 129.645 127.197 126.87 122.395C122.015 114.019 125.963 107.19 135.62 107.19C141.169 107.19 145.757 102.655 145.757 97.0532V87.6633C145.704 82.1147 141.169 77.5265 135.567 77.5265ZM92.3518 109.698C82.8018 109.698 75.0125 101.908 75.0125 92.3583C75.0125 82.8083 82.8018 75.0189 92.3518 75.0189C101.902 75.0189 109.691 82.8083 109.691 92.3583C109.691 101.908 101.902 109.698 92.3518 109.698Z",
    fill: "url(#paint0_linear_2396_1430)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2396_1430",
    x: 9.67644,
    y: 35.6764,
    width: 165.405,
    height: 159.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6618
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.988235 0 0 0 0 0.572549 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2396_1430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2396_1430",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.7 0 0 0 0 0.423984 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2396_1430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2396_1430",
    x1: 46.473,
    y1: 54.6262,
    x2: 117.144,
    y2: 134.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23C7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FC92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_1430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/IconSetting.73da4b437c5f594d7b6791755efe8491.svg";
export { ForwardRef as ReactComponent };